// src/components/EventList.js

import React from 'react';
import './Meet.css';

const events = [
  {
    title: 'Meet Disha Team',
    country: 'Thailand',
    eventName: 'InterPlas & Intermol Thailand',
    date: 'June 18–21, 2025',
  },
  {
    title: 'Meet Disha Team',
    country: 'Morocco',
    eventName: 'PLAST EXPO',
    date: 'June 23–26, 2025',
  },
];

const Meet = () => {
  return (
    <section className="event-section">
      <h2 className="section-heading">MEET DISHA TEAM</h2>
      <div className="event-list" data-aos="flip-up">
        {events.map((event, index) => (
          <div className="event-card" key={index}>
            <h3>{event.title}</h3>
            <p><strong>Country:</strong> {event.country}</p>
            <p><strong>Event:</strong> {event.eventName}</p>
            <p><strong>Date:</strong> {event.date}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Meet;
